import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { FiPlus, FiTrash2, FiEdit2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const defaultBlogs = [
    { id: 1, title: 'Why Professional Cleaning Improves Workplace Productivity', category: 'Commercial Cleaning', date: 'Oct 15, 2025' },
    { id: 2, title: 'The Hidden Costs of Poor Facility Maintenance', category: 'Facility Management', date: 'Oct 02, 2025' },
    { id: 3, title: 'Why Rope Access Is the Smart Choice for High-Rise Cleaning', category: 'Building Maintenance', date: 'Sep 28, 2025' },
];

const ManageBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchBlogs = async () => {
        try {
            // Try to fetch from API
            const response = await fetch('/api/blogs/read.php');
            if (response.ok) {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    const data = await response.json();
                    if (data.records && data.records.length > 0) {
                        setBlogs(data.records);
                    } else {
                        setBlogs(defaultBlogs);
                    }
                } else {
                    setBlogs(defaultBlogs);
                }
            } else {
                setBlogs(defaultBlogs);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setBlogs(defaultBlogs);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this blog?')) return;

        try {
            const response = await fetch('/api/blogs/delete.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            });

            if (response.ok) {
                toast.success('Blog deleted successfully');
                fetchBlogs(); // Refresh
            } else {
                toast.error('Failed to delete blog');
            }
        } catch (error) {
            console.error('Delete error:', error);
            toast.error('Failed to connect to server');
        }
    };

    return (
        <div>
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Manage Blogs</h1>
                    <p className="text-gray-500">Create, edit, and delete blog posts</p>
                </div>
                <Link to="/admin/blogs/create" className="flex items-center gap-2 bg-primary-600 text-white px-5 py-2.5 rounded-lg hover:bg-primary-700 transition-colors font-medium">
                    <FiPlus />
                    <span>Create New</span>
                </Link>
            </div>

            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-gray-50 border-b border-gray-100">
                                <th className="p-4 font-semibold text-gray-600">Title</th>
                                <th className="p-4 font-semibold text-gray-600">Category</th>
                                <th className="p-4 font-semibold text-gray-600">Date</th>
                                <th className="p-4 font-semibold text-gray-600 text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {isLoading ? (
                                <tr>
                                    <td colSpan="4" className="p-8 text-center text-gray-500">Loading...</td>
                                </tr>
                            ) : blogs.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="p-8 text-center text-gray-500">No blogs found.</td>
                                </tr>
                            ) : (
                                blogs.map((blog) => (
                                    <tr key={blog.id} className="hover:bg-gray-50 transition-colors">
                                        <td className="p-4 font-medium text-gray-800">{blog.title}</td>
                                        <td className="p-4 text-gray-600">
                                            <span className="px-2 py-1 bg-gray-100 rounded text-xs font-semibold">{blog.category}</span>
                                        </td>
                                        <td className="p-4 text-gray-500 text-sm">{blog.date}</td>
                                        <td className="p-4 text-right">
                                            <div className="flex items-center justify-end gap-2">
                                                <Link to={`/admin/blogs/edit/${blog.id}`} className="p-2 text-blue-500 hover:bg-blue-50 rounded-lg transition-colors" title="Edit">
                                                    <FiEdit2 />
                                                </Link>
                                                <button
                                                    onClick={() => handleDelete(blog.id)}
                                                    className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                                                    title="Delete"
                                                >
                                                    <FiTrash2 />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ManageBlogs;
